import { EventTypes } from '@racemap/sdk/schema/events';
import { useCallback } from 'react';
import { basePriceMapping } from '.';
import type { Price } from '../../components/CostCalculator/getProductPriceFactory';
import { useGetProductPrice } from './useGetProductPrice';

export function useEventBasePrice(eventType = EventTypes.REGULAR): Price | undefined {
  const getPrice = useGetProductPrice();
  const stripPrice = basePriceMapping[eventType];
  if (stripPrice == null) return undefined;

  const getEventPrice = useCallback(() => getPrice?.(stripPrice, 1), [getPrice, stripPrice]);
  return getEventPrice();
}
